/**
 * Luma Group
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';
import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';

/**
 * Controller for gallery.
 */
export default class extends Controller {
  static values = {
    selector: String,
  };

  /**
   * LightGallery instance.
   */
  lg;

  /**
   * Connect gallery.
   */
  connect() {
    this.lg = lightGallery(this.element, {
      licenseKey: '00000000-00000000-00000000-00000000',
      download: false,
      videoFacade: false,
      youTubeNoCookie: false,
      selector: this.selectorValue || 'a[href]',
      plugins: [lgVideo],
    });
  }

  /**
   * Disconnect gallery.
   */
  disconnect() {
    this.lg.destroy();
  }
}
